export default __webpack_public_path__ + "static/media/MarinaLogo2.f21720a7.png";